// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2_eqL","title":"Images90_title__x3Zhh","images":"Images90_images__B84g0"};